<template>
  <div class="modal-window large split active">
    <div class="grid-x split">
      <div class="cell large-6 flex-column">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3 class="icon-heading small">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
              <span class="icon-heading-title">
                <span class="title">Resultatbrev</span>
              </span>
            </h3>
          </div>
        </div>
        <div class="modal-window-body">
          Skriv ut resultatbrev.
        </div>

        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <template v-if="!skipSave">
                <a v-if="source && !$store.getters.isFormLoading" class="button primary small" @click="setStatusButtonClick()" href="javascript:;">Marker som behandlet</a>
                <a v-else class="button primary small" href="javascript:;" disabled>Marker som behandlet</a>
              </template>

              <a v-if="!$store.getters.isFormLoading" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
              <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            </div>
          </div>
        </div>
      </div>

      <div class="cell large-6 flex-column">
        <div class="modal-window-body no-padding">
          <div class="iframe-container pdf">
            <iframe v-if="source" id="htmlFrame" name="htmlFrame" frameborder="0" marginwidth="0" marginheight="0" width="100%" height="100%" scrolling="auto" :src="source"></iframe>
            <TheEmptyList v-if="!source && !$store.getters.isFormLoading" :title="'Resultatbrev'" :message="'Kunne ikke laste inn resultatbrev'" :large="false" :icon="'button-glyph-contract'"/>
            <TheLoader :active="!source && $store.getters.isFormLoading"/>
          </div>
        </div>
      </div>
    </div>

    <a v-if="!source" href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
      <span>Lukk</span>
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
    </a>
  </div>
</template>

<script>
import ResultatbrevService from '@/services/ResultatbrevService'
import bus from '@/plugins/event-bus'

export default {
  name: 'ResultatbrevPrintModal',
  props: {
    items: {
      type: Array,
      required: true
    },
    skipSave: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      source: false
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  methods: {
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    setStatusButtonClick: function () {
      bus.$emit('update-selected-status')
      this.$emit('close')
    },
    fetch: function () {
      this.setFormLoading(true)

      ResultatbrevService.loadManyForPrint(this.items)
        .then((response) => {
          let url = process.env.VUE_APP_AVANTI_API_URL + response.data

          this.source = url
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke opprette resultatbrev')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/ResultatbrevPrintModal.vue